import { createSlice } from "@reduxjs/toolkit";
import { mapDeviceUpdateToVimData } from "../../socket/deviceDashboardSocket";

const initialState = {
    devices: [],
}

const vimSlice = createSlice({
    name: "vimData",
    initialState,
    reducers: {
        setVimDevices: (state, action) => {
            state.devices = action.payload ?? [];
        },
        clearVimDevices: (state) => {
            state.devices = [];
        },
    }})

export const { setVimDevices, clearVimDevices } = vimSlice.actions;

export const selectVimDevices = (state) => state.vimData.devices;
export const selectVimDeviceById = (state, deviceId) =>
    state.vimData.devices.find((d) => d._id === deviceId || d.deviceId === deviceId);


export const mapVimItemToVimData = (item) => {
    if (!item?.latest) return undefined;
    const base = mapDeviceUpdateToVimData({ rows: [item.latest] }) ?? {};
    const fota = item.latest.configData?.fotaInfo?.[0];
    return {
        ...base,
        fwVersion: fota?.cFw,
        hwVersion: fota?.cHw,
        metadata: {
            ...base.metadata,
            organization: item.orgName,
        },
    };
};

// Maps the `nodes` array on a /nsync/profiles/:id/devices item into the shape
// ActiveNode.jsx expects — the same shape mapNsyncUpdateToActiveNodes produces,
// so the socket payload can transparently take over once it connects.
export const mapVimItemToActiveNodes = (item) => {
    if (!Array.isArray(item?.nodes)) return undefined;
    // Sorted copy (ascending nodeId) — item.nodes is Redux state, don't mutate it.
    const sorted = [...item.nodes].sort((a, b) => (a.nodeId < b.nodeId ? -1 : a.nodeId > b.nodeId ? 1 : 0));
    return sorted.map((node) => ({
        id: node.nodeId,
        ecuid: node.nodeId,
        soc: node.soc,
        soh: node.soh,
        packVoltage: node.packvoltage != null && !Number.isNaN(Number(node.packvoltage))
            ? `${Number(node.packvoltage).toFixed(1)}V`
            : undefined,
        packCurrent: node.current !== undefined ? `${node.current > 0 ? '+' : ''}${node.current}A` : undefined,
    }));
};

export default vimSlice.reducer;
